import { useDateRange } from '../../contexts/DateRangeContext';
import { useHistoricalFetching } from '../../hooks/useHistoricalData';
import { PeriodPicker } from '../../components/molecules/PeriodPicker/PeriodPicker';
import { EnergyGenerationChart } from '../charts/EnergyGenerationChart';
import { OutageTimelineChart } from '../charts/OutageTimelineChart';
import { CommunityOutagesChart } from '../charts/CommunityOutagesChart';
import { RenewableDistributionChart } from '../charts/RenewableDistributionChart';

export function HistoricalTab() {
  const { startDate, endDate, setStartDate, setEndDate } = useDateRange();
  const isFetching = useHistoricalFetching(startDate, endDate);

  const handleDateChange = (start: string, end: string) => {
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <section className="App-section">
      <PeriodPicker
        startDate={startDate}
        endDate={endDate}
        onDateChange={handleDateChange}
        isLoading={isFetching}
      />
      <div className="App-chartsGrid">
        <EnergyGenerationChart />
        <OutageTimelineChart />
        <CommunityOutagesChart />
        <RenewableDistributionChart />
      </div>
    </section>
  );
}
